import request from '@/utils/request'

// 分页查询合伙人列表（左侧列表）
export function listPagePartnerIncomeExpenditure(param) {
  return request({
    url: '/crmPartnerIncomeExpenditure/listPartner',
    method: 'post',
    data: param
  })
}

// 不分页查询合伙人下拉列表（仅用于下拉框）
export function listPartnerAll() {
  return request({
    url: '/crmPartnerIncomeExpenditure/listPartnerAll',
    method: 'post'
  })
}

// 分页查询项目收支列表
export function listPageProjectIncomeExpenditure(param) {
  return request({
    url: '/crmPartnerIncomeExpenditure/listProject',
    method: 'post',
    data: param
  })
}

// 分页查询额外收支列表
export function listPageExtraIncomeExpenditure(param) {
  return request({
    url: '/crmPartnerIncomeExpenditure/listExtra',
    method: 'post',
    data: param
  })
}

// 查询合伙人收支汇总数据
export function getPartnerSummary(param) {
  return request({
    url: '/crmPartnerIncomeExpenditure/getSummary',
    method: 'post',
    data: param
  })
}

// 新增额外收支
export function createExtraIncomeExpenditure(data) {
  return request({
    url: '/crmPartnerIncomeExpenditure/createExtra',
    method: 'post',
    data: data
  })
}

// 更新额外收支
export function updateExtraIncomeExpenditure(data) {
  return request({
    url: '/crmPartnerIncomeExpenditure/updateExtra',
    method: 'post',
    data: data
  })
}

// 删除额外收支
export function delExtraIncomeExpenditure(data) {
  return request({
    url: '/crmPartnerIncomeExpenditure/deleteExtra',
    method: 'post',
    data: data
  })
}